export const BUTTON_TEXTS = {
    SEND: 'Send message',
    INFO_LEARN_MORE: 'Learn more',
    INFO_READ_MORE: 'Read more',
    NEWS: 'View all news',
} as const;

export const BUTTON_TEXTS_PH = {
    SEND: 'Ipadala',
    INFO_LEARN_MORE: 'Alamin Pa',
    INFO_READ_MORE: 'Magbasa Pa',
    NEWS: 'Lahat ng Balita',
} as const;